<template>
  <svg
    width="21.000000pt"
    height="48.000000pt"
    viewBox="0 0 48.000000 48.000000"
    xmlns="http://www.w3.org/2000/svg"
    style="vertical-align: middle"
  >
    <g
      transform="translate(0.000000,48.000000) scale(0.100000,-0.100000)"
      fill="#ffffff"
      stroke="none"
    >
      <path
        d="M0 240 l0 -240 240 0 240 0 0 240 0 240 -240 0 -240 0 0 -240z m327
128 l53 -52 0 -128 0 -128 -140 0 -140 0 0 180 0 180 87 0 87 0 53 -52z"
      />
    </g>
    <g
      transform="translate(0.000000,48.000000) scale(0.100000,-0.100000)"
      fill="#50e6ff"
      stroke="none"
    >
      <path
        d="M90 240 l0 -190 150 0 150 0 0 140 0 140 -50 0 -50 0 0 50 0 50 -100
0 -100 0 0 -190z"
      />
    </g>
    <g
      transform="translate(0.000000,48.000000) scale(0.100000,-0.100000)"
      fill="#2b7ad3"
      stroke="none"
    >
      <path
        d="M280 375 l0 -55 57 0 57 0 -54 55 c-30 30 -56 55 -57 55 -2 0 -3 -25
-3 -55z"
      />
    </g>
    <g
      transform="translate(0.000000,48.000000) scale(0.100000,-0.100000)"
      fill="#62b3e6"
      stroke="none"
    >
      <path
        d="M330 375 c30 -30 57 -55 59 -55 3 0 -19 25 -49 55 -30 30 -57 55 -59
55 -3 0 19 -25 49 -55z"
      />
    </g>
    <g
      transform="translate(0.000000,48.000000) scale(0.100000,-0.100000)"
      fill="#63e8ff"
      stroke="none"
    >
      <path
        d="M90 419 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5
-10 -11z"
      />
      <path
        d="M90 60 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4
-4 -4 -10z"
      />
      <path
        d="M375 60 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8
-4 -11 -10z"
      />
    </g>
    <g
      transform="translate(0.000000,48.000000) scale(0.100000,-0.100000)"
      fill="#ccf7fe"
      stroke="none"
    />
    <g
      transform="translate(0.000000,48.000000) scale(0.100000,-0.100000)"
      fill="#3385db"
      stroke="none"
    >
      <path
        d="M280 330 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4
-4 -4 -10z"
      />
    </g>
    <g
      transform="translate(0.000000,48.000000) scale(0.100000,-0.100000)"
      fill="#ccf8ff"
      stroke="none"
    />
    <g
      transform="translate(0.000000,48.000000) scale(0.100000,-0.100000)"
      fill="#47c7f3"
      stroke="none"
    />
    <g
      transform="translate(0.000000,48.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    />
    <g
      transform="translate(0.000000,48.000000) scale(0.100000,-0.100000)"
      fill="#ff0000"
      stroke="none"
    />
    <g
      transform="translate(0.000000,48.000000) scale(0.100000,-0.100000)"
      fill="#00ff00"
      stroke="none"
    />
    <g
      transform="translate(0.000000,48.000000) scale(0.100000,-0.100000)"
      fill="#ffff00"
      stroke="none"
    />
    <g
      transform="translate(0.000000,48.000000) scale(0.100000,-0.100000)"
      fill="#0000ff"
      stroke="none"
    />
    <g
      transform="translate(0.000000,48.000000) scale(0.100000,-0.100000)"
      fill="#ff00ff"
      stroke="none"
    />
    <g
      transform="translate(0.000000,48.000000) scale(0.100000,-0.100000)"
      fill="#00ffff"
      stroke="none"
    />
    <g
      transform="translate(0.000000,48.000000) scale(0.100000,-0.100000)"
      fill="#ffffff"
      stroke="none"
    />
    <g
      transform="translate(0.000000,48.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    />
  </svg>
</template>

<script>
export default {
  name: 'SharePointFileIcon',
};
</script>
